let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fsSg2")).then(() => parcelRequire('l5ru8'));